<script>
import { Bar, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
    extends: Bar,
    mixins: [reactiveProp],
    computed: {
        options() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    titleFontSize: 14,
                    titleMarginBottom: 8,
                    bodyFontSize: 15,
                    bodySpacing: 10,
                    callbacks: {
                        label: (tooltipItems, data) => {
                            const index = tooltipItems.index;
                            if (tooltipItems.datasetIndex === 0) {
                                return `${
                                    this.chartData.labels[index]
                                }  ${_.getMoneyFormat(
                                    this.chartData.datasets[0].data[index]
                                )}`;
                            }
                            return `${
                                this.chartData.labels[index]
                            }  ${_.getMoneyFormat(
                                this.chartData.datasets[1].data[index]
                            )}`;
                        },
                    },
                },
                legend: this.legend
                    ? {
                          position: "left",
                          align: "start",
                      }
                    : {
                          display: false,
                      },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                display: false,
                            },
                            afterTickToLabelConversion: function (q) {
                                for (var tick in q.ticks) {
                                    q.ticks[tick] = _.getMoneyFormat(
                                        q.ticks[tick]
                                    );
                                }
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                        },
                    ],
                },
            };
        },
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options);
    },
};
</script>
